module.exports = __webpack_public_path__ + "static/btoc-ea06d578c892f84c331f53e37f18dff1.jpg";